import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import CustomLoader from '../../common/CustomLoader';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-monokai';

export default class CustomJSForm extends Component {
  static propTypes = {
    content: PropTypes.object,
  };

  handleCustomJsSubmit = (values) => {
    this.props.handleCustomJsSubmit(values);
  };

  render() {
    const { content, showCustomJSLoader, togglestate } = this.props;
    let customJS = content && content.customJS ? content.customJS : '';

    return (
      <>
        <Formik
          initialValues={{ customJS }}
          enableReinitialize={true}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            this.handleCustomJsSubmit(values);
            setSubmitting(false);
            resetForm({ values: { customJS: '' } });
          }}
        >
          {({ isSubmitting, setFieldValue, setFieldTouched, resetForm, errors, values }) => {
            return (
              <Form className="form-horizontal">
                <div className="row mx-auto">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <AceEditor
                        mode="javascript"
                        theme="github"
                        name="customJS"
                        value={values.customJS}
                        onChange={(value) => setFieldValue('customJS', value)}
                        onBlur={() => setFieldTouched('customJS', true)}
                        rows={10}
                        fontSize={16}
                        showPrintMargin={false}
                        width="100%"
                        height={togglestate ? '75vh' : '300px'}
                        placeholder={`Insert your JavaScript Code here..\nEg. console.log('My Custom Code.')`}
                      />
                      <ErrorMessage name="customJS">
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12 text-right">
                    {content && content.customJS ? (
                      <button
                        type="reset"
                        className="btn btn-default btn-md"
                        onClick={() => {
                          resetForm({ values: { customJS: '' } });
                          setFieldValue('customJS', '');
                        }}
                      >
                        <span>
                          <i className={`wb ${drapcodeIcon('eraser')}`}></i>&nbsp;Reset
                        </span>
                      </button>
                    ) : (
                      ''
                    )}
                    &nbsp;
                    {!(content && content.customJS) ? (
                      <button
                        type="submit"
                        className="btn btn-theme-submit btn-md"
                        disabled={isSubmitting && showCustomJSLoader ? 'disabled' : ''}
                        title="Add Custom JS"
                      >
                        <i className={`wb ${drapcodeIcon('create')}`}></i>&nbsp;Add
                        <CustomLoader loading={showCustomJSLoader} />
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-theme-submit btn-md"
                        disabled={isSubmitting && showCustomJSLoader ? 'disabled' : ''}
                        title="Update Custom JS"
                      >
                        <i className={`wb ${drapcodeIcon('update')}`}></i>&nbsp;Update
                        <CustomLoader loading={showCustomJSLoader} />
                      </button>
                    )}
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </>
    );
  }
}
